import React, { useEffect, useContext, useState } from 'react';
import _ from 'lodash';
import { Button, Popup } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import VImage from '../VImage/VImage';
import VSvg from '../VSvg/VSvg';
import VFrame from '../VFrame/VFrame';
import VGrid from '../VGrid/VGrid';
import VLine from '../VLine/VLine';
import VTextEditor from '../VTextEditor/VTextEditor';
import Droppable from '../DnD/Droppable';
import { useSelector, useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import { FontsStyle, TextSpacingStyle, ListBlockStyle } from '../GlobalStyle/GlobalStyle';
import juiceClient from 'juice/client';
import ZoomTool from '../ZoomTool/ZoomTool';
import VToolbar from '../VToolbar/VToolbar';
import Background from '../Background/Background';
import { calculateDroppedEntitySize } from '../../utils/design.utils';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useTranslation } from 'react-i18next';
import './Workplace.css';
import { ReactSVG } from 'react-svg';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';

const Workplace = (props) => {
  const { t } = useTranslation();
  const { _type } = useParams();
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const designHeight = useSelector(state => state.design.height);
  const designWidth = useSelector(state => state.design.width);
  const pages = useSelector(state => state.design.pages);
  const templateId = useSelector(state => state.template.templateId);
  const fontsLoaded = useSelector(state => state.design.fontsLoaded);
  const spacingStyleClasses = useSelector(state => state.design.spacingStyleClasses);
  const listBlockStyleClasses = useSelector(state => state.design.listBlockStyleClasses);
  const scale = useSelector(state => state.design.scale);
  const user = useSelector(state => state.authentication.user);
  const isOperationalUser = ['operator', 'admin'].includes(user.role);
  const [entitiesList, setEntitiesList] = useState({});
  // const [isLoaded, setIsLoaded] = useState(false)
  const pagesRef = [];
  let lastGroupCreated;

  useEffect(() => {
    // console.log('Workplace changed', props.mode);
    // console.log('document.readyState', document.readyState);
  });
  
  useEffect(() => {
    // console.log('entitiesList', entitiesList);
    // setTimeout(() => {
    //   entityOnload(0);
    // }, 10000);
  },[entitiesList]);
  useEffect(() => {
    const entitiesStatus = [];
    pages.map(page => {
      page.entities.map(entity => {
        entitiesStatus.push({ id: entity.id, type: entity.type, loaded: false });
      });
    });
    setEntitiesList(entitiesStatus);
  },[pages]);

  const entityOnload = entityId => {
    const entitiesStatus = entitiesList;
    // console.log('entitiesStatus', entitiesStatus);
    // entitiesStatus.find(entity => entity.id === entityId).loaded = true;
    const newStatus = entitiesStatus.map(entity => {
      if (entity.id === entityId) {
        return { ...entity, loaded: true };
      }
      return { ...entity };
    });
    // console.log("newStatus",newStatus);
    setEntitiesList(entitiesStatus);
  }

  const onDropped = (item, monitor) => {
    const { x, y } = monitor.getClientOffset();
    const initClient = monitor.getInitialClientOffset();
    const initSourceClient = monitor.getInitialSourceClientOffset();
    const offsetX = initClient.x - initSourceClient.x;
    const offsetY = initClient.y - initSourceClient.y;
    const keyId = window.$_getEntityKey();
    const artboardOffset = document.getElementsByClassName('artboard')[item.pageId].getBoundingClientRect();
    const { droppedWidth, droppedHeight, droppedScale } = calculateDroppedEntitySize(
      designWidth,
      designHeight,
      item.data.width,
      item.data.height,
    );
    const translateX = x - artboardOffset.left - offsetX * item.data.scale * droppedScale;
    const translateY = y - artboardOffset.top - offsetY * item.data.scale * droppedScale;

    const style = {
      master: {
        transform: `translateX(${translateX ? translateX : 0}px) translateY(${
          translateY ? translateY : 0
        }px) rotate(0deg) scaleX(1) scaleY(1)`,
      },
      inner: { width: droppedWidth, height: droppedHeight },
    };

    var entity;
    switch (item.type) {
      case 'Image':
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Video':
        style.master = { ...style.master, height: style.inner.height, width: style.inner.width };
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Text':
        style.master.transform = `translateX(${translateX}px) translateY(${translateY}px) rotate(0deg) scaleX(${droppedScale /
          2}) scaleY(${droppedScale / 2})`;
        style.inner = {};
        dispatch(designActions.addNewEditorState({ id: keyId, contentType: 'html', ...item.data }));
        entity = {
          type: item.type,
          keyId,
          style,
        };
        break;
      case 'Shape':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
        };
        break;
      case 'Vector':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          resource: item.data.id,
        };
        break;
      case 'Frame':
        dispatch(designActions.addNewSVGState({ id: keyId, data: [] }));
        entity = {
          type: item.type,
          keyId,
          style,
          data: item.data,
          resource: item.data.id,
        };
        break;
      case 'Grid':
        entity = {
          type: item.type,
          keyId,
          style,
          data: item.data,
          resource: item.data.id,
        };
        break;
      case 'Line':
        entity = {
          type: item.type,
          keyId,
          style,
          src: item.data.src,
          data: {},
          resource: item.data.id,
        };
        break;
      case 'Background':
        // The background is fixed component and must use known media
        // so changed "item.type" to "Image"
        dispatch(designActions.changeEntity(item.pageId, 'Background', item.data.id, item.data.src, 'Image'));
        break;
    }

    entity &&
      dispatch(
        designActions.addEntity(item.pageId, {
          entities: [{ id: keyId, type: item.type }],
          states: { [keyId]: entity },
        }),
      );
  };

  const saveDesign = extension => {
    _exportAllStyles().then(styles => {
      _inlineStyle(styles).then(previewPages => {
        if (_type === 'template') dispatch(designActions.saveAsTemplate(previewPages, extension));
        else if (_type === 'text') dispatch(designActions.saveAsText(previewPages, extension));
        else dispatch(designActions.save(previewPages));
      });
    });
  };

  const _exportAllStyles = () => {
    return new Promise(resolve => {
      let styles = '';
      const allStyles = document.getElementsByTagName('style');
      for (let style of allStyles) {
        if (style && style.firstChild) {
          for (let node of style.childNodes) {
            styles = styles.concat(node.data);
          }
        }
      }
      resolve(styles);
    });
  };

  const _inlineStyle = styles => {
    return new Promise(resolve => {
      const artboards = document.getElementsByClassName('artboard');
      if (_.get(artboards, 'length', 0) > 0) {
        const previewPages = [];
        Array.from(artboards).forEach(artboard => {
          previewPages.push(juiceClient.inlineContent(artboard.outerHTML, styles));
        });
        resolve(previewPages);
      }
    });
  };

  const logScroll = event => {
    const activePage = { index: 0, visibleHeight: 0 };
    const viewportHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    pagesRef.forEach((pageRef, index) => {
      if (viewportHeight + scrollTop > pageRef.offsetTop && pageRef.offsetTop + pageRef.clientHeight > scrollTop) {
        const topHiddenHeight = scrollTop > pageRef.offsetTop ? scrollTop - pageRef.offsetTop : 0;
        const bottomHiddenHeight =
          viewportHeight + scrollTop < pageRef.offsetTop + pageRef.clientHeight
            ? pageRef.offsetTop + pageRef.clientHeight - (viewportHeight + scrollTop)
            : 0;
        if (pageRef.clientHeight - (topHiddenHeight + bottomHiddenHeight) > activePage.visibleHeight) {
          activePage.visibleHeight = pageRef.clientHeight - (topHiddenHeight + bottomHiddenHeight);
          activePage.index = index;
        }
      }
    });
    activePageRef.current = activePage.index;
  };

  const addNoteToPage = pageId => {};

  const afterSelect = selectedTargets => {
    // console.log('---- aftetSelect');
    let targets = [];
    selectedTargets.map(selectedTarget => {
      const dataTarget = selectedTarget.dataset.target;
      targets.push(dataTarget);
    });
    dispatch(designActions.changeRectSelection(targets));
  };

  const createEntity = (entity, index, groupId) => {
    switch (entity.type) {
      case 'Image':
        return (
          <VImage
            pageId={index}
            key={entity.id}
            entityId={entity.id}
            type={entity.type}
            dataTarget={`P_${entity.id}`}
            pageSize={{
              width: designWidth,
              height: designHeight,
            }}
          />
        );
      case 'Video':
        return (
          <VImage
            pageId={index}
            key={entity.id}
            entityId={entity.id}
            type={entity.type}
            dataTarget={`P_${entity.id}`}
            pageSize={{
              width: designWidth,
              height: designHeight,
            }}
          />
        );
      case 'Text':
        return (
          <VTextEditor
            key={entity.id}
            pageId={index}
            entityId={entity.id}
            className="moveable rSable "
            dataTarget={`T_${entity.id}`}
          />
        );
      case 'Shape':
        return (
          <VSvg
            key={entity.id}
            dataType="Shape"
            pageId={index}
            entityId={entity.id}
            className="moveable rSable "
            dataTarget={`S_${entity.id}`}
          />
        );
      case 'Vector':
        return (
          <VSvg
            key={entity.id}
            dataType="Vector"
            pageId={index}
            groupId={groupId}
            entityId={entity.id}
            className="moveable rSable "
            dataTarget={`V_${entity.id}`}
          />
        );
      case 'Frame':
        return (
          <VFrame
            id={`_${entity.id}_`}
            dataType="Frame"
            key={entity.id}
            pageId={index}
            entityId={entity.id}
            type="Frame"
            className="moveable rSable  vFrame"
            dataTarget={`F_${entity.id}`}
          />
        );
      case 'Grid':
        return (
          <VGrid
            // division
            key={entity.id}
            dataType="Grid"
            pageId={index}
            entityId={entity.id}
            className="moveable rSable  vGridHolder"
            dataTarget={`G_${entity.id}`}
            size={{ width: designWidth, height: designHeight }}
          />
        );
      case 'Line':
        return (
          <VLine
            key={entity.id}
            dataType="Line"
            pageId={index}
            entityId={entity.id}
            className="moveable rSable  vLineHolder"
            dataTarget={`L_${entity.id}`}
            // size={{ width: designWidth, height: designHeight }}
          />
        );
    }
  };

  return (
    <div id="workplace">
      <FontsStyle fonts={fontsLoaded} authToken={user.authToken} />
      <TextSpacingStyle styleClasses={Object.values(spacingStyleClasses)} />
      <ListBlockStyle styleClasses={Object.values(listBlockStyleClasses)} />
      {props.mode != "export" && (
        <>
          <div className="wpCover"></div>
          <div id="toolbar">
            <VToolbar />
            {templateId && isOperationalUser && (
              <>
                <span style={{ color: 'black', direction: 'ltr', flex: 'auto', fontSize: '150%' }}>
                  <Button onClick={() => saveDesign()}>
                    <ReactSVG src={icons.save} />
                  </Button>
                  {_type !== 'text' && <Button onClick={() => saveDesign('gif')} content={'GIF'} />}
                </span>
              </>
            )}
          </div>
        </>
      )}
      <div id="artboardHolder" className="onLoad" onScroll={logScroll}>
        {/* <Selection
          selectedClass="rsSelect"
          pageScale={scale}
          container="rectSelectHolder"
          target=".moveable"
          afterSelect={afterSelect}
          disable={selectedEntity}
        /> */}
        <div id="selectoHolder" />
        <div id="rectSelectHolder" className="artboardHolder">
          <div className="artboardHolderInner">
            <div className="artboardHolderInner2">
              {pages.map((page, index) => {
                return (
                  <div key={index} ref={ref => pagesRef.push(ref)} className="page">
                    <div className="pageInner">
                    {props.mode != "export" && (
                      <div className="pageToolbar" style={{ width: `${designWidth}px` }}>
                        <div className="pageToolbarHolder">
                          {/* <div className="pageToolbarToggle">Page Toolbar</div> */}
                          <div className="innerPageToolbar">
                            <div className="pageNumber">
                              {t('page')} - {index + 1}{' '}
                            </div>
                            <div className="pageTitle">{t('addPageTitle')}</div>
                            <div className="separator"></div>
                            <div className="pageToolbarTools">
                              {/* <Popup
                                content={t('addNotes')}
                                trigger={<Button icon="file outline" compact />}
                              /> */}
                              <Popup
                                content={t('moveUp')}
                                trigger={
                                  <Button
                                    icon="chevron up"
                                    compact
                                    onClick={() => {
                                      pagesRef[index - 1].scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                      });
                                      activePageRef.current = index - 1;
                                    }}
                                    disabled={index === 0}
                                  />
                                }
                              />
                              <Popup
                                content={t('moveDown')}
                                trigger={
                                  <Button
                                    icon="chevron down"
                                    compact
                                    onClick={() => {
                                      pagesRef[index + 1].scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                      });
                                      activePageRef.current = index + 1;
                                    }}
                                    disabled={index === pages.length - 1}
                                  />
                                }
                              />
                              <Popup
                                content={t('copyPage')}
                                trigger={
                                  <Button
                                    icon="copy outline"
                                    compact
                                    onClick={() => dispatch(designActions.actionOnPage('copy', index))}
                                  />
                                }
                              />
                              <Popup
                                content={t('deletePage')}
                                trigger={
                                  <Button
                                    icon="trash alternate outline"
                                    compact
                                    onClick={() => dispatch(designActions.actionOnPage('delete', index))}
                                  />
                                }
                              />
                              <Popup
                                content={t('addPage')}
                                trigger={
                                  <Button
                                    icon="add"
                                    compact
                                    onClick={() => dispatch(designActions.actionOnPage('add', index))}
                                  />
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                      <div className="pageHolder">
                        <div className="pageSize">
                          <div
                            className="artboard"
                            style={{
                              width: `${designWidth}px`,
                              height: `${designHeight}px`,
                              backgroundColor: _.get(page, 'background.color', '#fff'),
                              position: 'relative',
                            }}
                          >
                            {/* <VMoveable
                              artboardSize={{
                                width: `${designWidth}px`,
                                height: `${designHeight}px`,
                              }}
                              designScale={scale}
                              page={index}
                            /> */}
                            <Droppable
                              type="Master"
                              pageId={index}
                              acceptList={[
                                'Image',
                                'Video',
                                'Text',
                                'Shape',
                                'Frame',
                                'Vector',
                                'Grid',
                                'Line',
                                'Background',
                              ]}
                              onDropped={onDropped}
                            >
                              <div
                                id={`artboardContainer_${index}`}
                                className={`artboardContainer`}
                                style={{
                                  width: `${designWidth}px`,
                                  height: `${designHeight}px`,
                                }}
                              >
                                <div className="onLoadCover"></div>
                                <div className="artboardContent">
                                  <div
                                    id={`B_${index}`}
                                    className="background moveable rSable"
                                    style={_.get(page, 'background.media.style.master', {})}
                                    data-target={`B_${index}`}
                                    data-type={'background'}
                                  >
                                    <div className="backgroundDC"></div>
                                    <Droppable
                                      pageId={index}
                                      entityId="Background"
                                      type="Image"
                                      acceptList={['Image', 'Video']}
                                    >
                                      <Background src="" type="" pageId={index} data={page.background} />
                                    </Droppable>
                                  </div>
                                  {page.entities.map(entity => {
                                    if (entity.groupId) {
                                      if (lastGroupCreated === entity.groupId) return;
                                      lastGroupCreated = entity.groupId;
                                      return (
                                        <div id={`_${entity.groupId}_`} className="group groupMoveable rSable">
                                          {entity.entities.map(groupEntity => {
                                            return createEntity(groupEntity, index, entity.groupId);
                                          })}
                                        </div>
                                      );
                                    } else {
                                      return createEntity(entity, index);
                                    }
                                  })}
                                </div>
                              </div>
                            </Droppable>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {props.mode != 'export' && (
              <div className="artboardBottom">
                <Button
                  fluid
                  content={`${t('addPage')} +`}
                  onClick={() => dispatch(designActions.actionOnPage('add', pages.length - 1))}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {props.mode != 'export' && (
        <ZoomTool pagesCount={pages.length} originWidth={designWidth} originHeight={designHeight} />
      )}
    </div>
  );
};

export default Workplace;
